<template>
  <ion-card
    color="light"
    class="bg-white border-default no-shadow spacing-xs ion-no-margin filter-card"
  >
    <ion-row>
      <ion-col
        :size="isExpanded ? '12' : '4'"
        class="ion-align-items-center justify-space-center d-flex"
      >
        <UserAvatar :width="isExpanded ? 128 : 75" :height="isExpanded ? 128 : 75" />
      </ion-col>
      <ion-col
        :size="isExpanded ? '12' : '8'"
        class="ion-justify-content-center ion-align-items-start d-flex flex-column"
      >
        <h4
          class="h4 ion-justify-content-center w-100 text-align-center"
          :class="isExpanded ? 'ion-align-items-center' : 'text-align-left'"
        >
          {{ fullName }}
        </h4>
        <template v-if="!inProfileView">
          <ion-button class="mt-8" expand="block" fill="outline" size="small" @click="goToProfile">
            {{ t('profile.showProfile') }}
            <ion-icon slot="end" :icon="chevronForwardOutline"></ion-icon>
          </ion-button>
        </template>
      </ion-col>
    </ion-row>
  </ion-card>
</template>
<script setup lang="ts">
  import { chevronForwardOutline } from 'ionicons/icons';
  import { IonButton, IonCard, IonCol, IonIcon, IonRow } from '@ionic/vue';
  import UserAvatar from '@/components/shared/avatar/UserAvatar.vue';
  import { useI18n } from 'vue-i18n';
  import { useAuth } from '@/composables/useAuth';
  import router from '@/router';
  import { computed } from 'vue';

  const { fullName } = useAuth();
  const { t } = useI18n();

  const props = defineProps({
    inProfileView: {
      type: Boolean,
      required: false,
      default: false,
    },
    expanded: {
      type: Boolean,
      required: false,
      default: false,
    },
    showEdit: {
      type: Boolean,
      required: false,
      default: false,
    },
  });

  const isExpanded = computed(() => {
    return props.expanded;
  });

  const goToProfile = () => {
    router.push({ name: 'profile.my' });
  };
</script>
<style scoped lang="scss">
  ion-button {
    height: 35px;
  }
</style>
